module.exports = __webpack_public_path__ + "static/media/baka.0e364cd7.mp3";